module.exports = __webpack_public_path__ + "img/reference-josef-otten.b9c521f6.jpg";